import React, { useEffect, useState } from 'react';
import apiClient from '../../../../../Services/ApiClient';
import Loading, { LoadingSize } from '../../../../../Components/Loading';
import {
	isAudio,
	isImage,
	responseDataToBlob,
} from '../Helpers/QuestionnaireResultWithScoringDetailValueCell.helper';

interface Props {
	fileId: string;
	patientId?: string;
	transcription?: string | null;
}

const QuestionnaireResultWithScoringDetailFileValue: React.FC<Props> = ({
	fileId,
	patientId,
	transcription,
}) => {
	const [fileUrl, setFileUrl] = useState<string>();
	const [mimeType, setMimeType] = useState<string>();
	const [filename, setFilename] = useState<string>();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(false);

	useEffect(() => {
		let objectUrl: string | undefined;

		const loadFile = async () => {
			if (!patientId || !fileId) {
				setError(true);
				setIsLoading(false);
				return;
			}

			try {
				setIsLoading(true);
				setError(false);

				const response = await apiClient.get(`/files/${patientId}/${fileId}`, {
					responseType: 'arraybuffer',
				});

				const blob = await responseDataToBlob(response.data);

				objectUrl = URL.createObjectURL(blob);

				setFileUrl(objectUrl);
				setMimeType(blob.type);
				setFilename(fileId);
			} catch {
				setError(true);
			} finally {
				setIsLoading(false);
			}
		};

		loadFile();

		return () => {
			if (objectUrl) {
				URL.revokeObjectURL(objectUrl);
			}
		};
	}, [patientId, fileId]);

	if (isLoading) return <Loading size={LoadingSize.SMALL} />;
	if (error || !fileUrl) return <></>;

	if (isImage(mimeType)) {
		return (
			<img
				src={fileUrl}
				alt={filename || 'Soubor'}
				style={{ maxWidth: '300px' }}
			/>
		);
	}

	if (isAudio(mimeType)) {
		return (
			<>
				{transcription ? (
					<div style={{ marginBottom: '8px', fontWeight: 600 }}>
						Přepis: {transcription}
					</div>
				) : (
					<div
						style={{
							marginBottom: '8px',
							color: '#d32f2f',
							fontWeight: 600,
						}}>
						Zvukový záznam se nepodařilo přepsat.
					</div>
				)}

				<audio src={fileUrl} controls />
			</>
		);
	}

	return <></>;
};

export default QuestionnaireResultWithScoringDetailFileValue;
